<style lang="scss" scoped>
  @import '../../styles/helpers/main';
  @import '../../styles/vars/main';
  .photo {
    display: flex;
    height: 100%;
    &__lightbox {
      flex: 1 0 0;
      position: relative;
      background-color: color('grey', 'darker');
      overflow: hidden;
    }
    &__sliderNavi {
      z-index: 10;
      position: relative;
    }
    &__actions {
      margin-bottom: space('comfortable')
    }
    &__actions-item{
      svg{
        @include svg-dim("base");
      }
    }
    &__actions-item + &__actions-item{
      margin-left: space("tight");
    }
    &__lightbox-img-container {
      background-color: red;
    }
    &__aside {
      width: 450px;
      transition: all 1s  ease-out;
      margin-left: space("cozy");
      &--expanded{
        max-width: 600px;
        width: 50%;
      }
    }
    &__title {
      margin-bottom: space('comfortable');
    }
    &__description {
      height: 400px;
      margin-bottom: space('comfortable');
    }
    &__img{
      position: absolute;
      max-height: 100%;
      max-width: 100%;
      width: auto;
      height: auto;
      margin: auto;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      &-enter-active, &-leave-active {
        transition: all 0.5s cubic-bezier(0.80, 0.20, 0.10, 1.00);
      }
      &-enter {
        opacity: 0;
        transform: scale(1.05);
        // transform: scaleX(1.1);
        // transform: translateX(50%) scale(1.05);
      }
      &-leave-to {
        opacity: 0;
        transform: scale(0.9);
        // transform: translateY(-10%);;
        // transform: translateX(-50%) scale(0.8);
      }
    }
    &__info__label {
      width: 60px;
      display: inline-block;
    }
    &__footer {
      display: flex;
      justify-content: space-between;
      flex-shrink: 0;
    }
  }
  .isFavourite {
    fill: color('flamingo');
  }
  .sliderNavi {
    position: relative;
    height: 100%;
    &__arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: space('cozy');
      svg{
        @include svg-dim("large");
      }
    }
    &__arrow.--right {
      left: auto;
      right: space('cozy');
    }
  }

  .edit {
    display: flex;
    flex-direction: column;
    height: 100%;
    &__headline {
      margin-bottom: space('comfortable');
    }
    &__title {
      margin-bottom: space('comfortable');
    }
    &__description {
      height: 100%;
      margin-bottom: space('comfortable');
    }
    &__footer {

    }
  }
</style>
<template>
  <div class="photo">
    <div class="photo__lightbox">
      <!-- <figure> -->
        <div class="photo__sliderNavi sliderNavi">
          <v-button class="button-circle --grey sliderNavi__arrow" @click.prevent="prevSlide">
          <svg>
            <use xlink:href="#arrow-left"></use>
          </svg>
        </v-button>
        <v-button class="button-circle --grey sliderNavi__arrow --right" @click.prevent="nextSlide">
          <svg>
            <use xlink:href="#arrow-right"></use>
          </svg>
        </v-button>
        </div>
        <transition name="photo__img">
          <img :key="activePhotoIndex" :src="getUrl" alt="" class="photo__img">
        </transition>
      <!-- </figure> -->
    </div>

    <div class="photo__aside" :class="[edit == true ? 'photo__aside--expanded' : '']">
      <div class="photo__actions">
        <!-- <v-button class="button-circle --grey photo__actions-item" @click.prevent="editCopy">
          <svg>
            <use xlink:href="#edit"></use>
          </svg>
        </v-button> -->
        <v-button class="button-circle --grey photo__actions-item" @click.prevent="visibility">
          <svg v-if="visible == 0">
              <use xlink:href="#hidden"></use>
          </svg>
          <svg v-else>
              <use xlink:href="#visible"></use>
          </svg>
        </v-button>
        <v-button class="button-circle --grey photo__actions-item" @click.prevent="toggleFavourite">
          <svg v-if="favourite == 0">
            <use xlink:href="#favourite"></use>
          </svg>
          <svg v-else class="isFavourite">
            <use xlink:href="#isFavourite"></use>
          </svg>
        </v-button>
      </div>
      <input type=text spellcheck="false" :name="'title'" :value="name" class="textfield --headline photo__title" ref="newHeadline" >
      <textarea spellcheck="false"  class="textarea photo__description" name="" id="" cols="30" rows="10" ref="newDescription" :value="description">
      </textarea>
      <ul class="list photo__info">
        <li><span class="photo__info-label">created:</span> {{created}}</li>
        <li><span class="photo__info-label">updated:</span> {{updated}}</li>
      </ul>
      <div class="photo__footer">
        <v-button cssClass="button --secondary" @click="cancel">Abbrechen</v-button>
        <v-button @click="save">Speichern</v-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Button from '../button';
import Headline from '../headline';

export default {
  components: {
    'v-button': Button,
    'v-headline': Headline
  },
  data() {
    return {
      edit: false
    };
  },
  props: {

  },
  mounted() {

  },
  computed: {
    ...mapGetters([
      'content',
      'view',
      'sortByValue',
      'activeId',
      'activePhotoId',
      'baseURL'
    ]),
    activePhotoIndex: {
      get() {
        return this.$store.getters.activePhotoIndex;
      },
      set(id) {
        this.$store.commit('activePhotoIndex', id);
      }
    },
    data() {
      return this.$store.getters.sortedData;
    },
    name() {
      return this.data[this.activePhotoIndex].name;
    },
    id() {
      return this.data[this.activePhotoIndex].id;
    },
    favourite() {
      return this.data[this.activePhotoIndex].favourite;
    },
    visible() {
      return this.data[this.activePhotoIndex].visible;
    },
    created() {
      return this.data[this.activePhotoIndex].created_at;
    },
    updated() {
      return this.data[this.activePhotoIndex].updated_at;
    },
    description() {
      return this.data[this.activePhotoIndex].description;
    },
    getUrl() {
      return `${this.baseURL}/large_${this.data[this.activePhotoIndex].filename}`;
    }
  },
  methods: {
    nextSlide() {
      if (this.activePhotoIndex === this.data.length - 1) {
        this.activePhotoIndex = 0;
      } else {
        this.activePhotoIndex++;
      }
    },
    prevSlide() {
      if (this.activePhotoIndex === 0) {
        this.activePhotoIndex = this.data.length - 1;
      } else {
        this.activePhotoIndex--;
      }
    },
    visibility() {
      const visible = (this.visible === '1') ? '0' : '1';
      const apiPath = `photo/${this.id}`;
      const target = 'photos';
      const parentId = this.activeId;
      const targetId = this.id;
      this.$store.dispatch('update', { props: { visible }, apiPath, target, parentId, targetId }).then(() => {
      });
    },
    editCopy () {
      this.edit = !this.edit;
    },
    save() {
      const apiPath = `photo/${this.id}`;
      const target = 'photos';
      const parentId = this.activeId;
      const targetId = this.id;
      const title = this.$refs.newHeadline.value;
      const description = this.$refs.newDescription.value;
      this.$store.dispatch('update', { props: { 'name': title, 'description': description }, apiPath, target, parentId, targetId }).then((data) => {
      });
    },
    cancel() {
      this.$store.commit('overlay_isOpen', false);
    },
    toggleFavourite() {
      const favourite = (this.favourite === '1') ? '0' : '1';
      const apiPath = `photo/${this.id}`;
      const target = 'photos';
      const parentId = this.activeId;
      const targetId = this.id;
      this.$store.dispatch('update', { props: { favourite }, apiPath, target, targetId, parentId }).then(() => {
      // console.log('data loaded');
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/album/photo.vue